import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import Page from 'modules/Page';
import * as constants from './constants';

const NotificationsPage = lazyWithSuspense(() => import('./NotificationsPage'));

const page: Page = {
  title: constants.TITLE,

  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage({ WrappedPage: NotificationsPage, titleFn: () => i18n._(constants.TITLE) }),
};

export default page;
